import { render } from "./ExpertStatisticsFullExtensionReport.vue?vue&type=template&id=48fae1a6&scoped=true"
import script from "./ExpertStatisticsFullExtensionReport.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsFullExtensionReport.vue?vue&type=script&lang=js"

import "./ExpertStatisticsFullExtensionReport.vue?vue&type=style&index=0&id=48fae1a6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fae1a6"]])

export default __exports__